import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "context/AuthContext";

/**
 * 카카오 로그인 콜백 (/oauth/kakao).
 *  - authorize 후 ?code=... (&state=redirect) 로 돌아옴.
 *  - code 를 AuthContext.kakaoLogin 으로 백엔드에 보내 JWT 수신 → 원래 경로로 이동.
 *  - 사용자가 동의 취소 시 ?error=access_denied 로 돌아옴 → 로그인 화면으로.
 *
 * ⚠️ 백엔드(/auth/kakao) 미구축 동안에는 토큰 교환 단계에서 실패 → 로그인 화면으로 복귀.
 */
const KakaoCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { kakaoLogin } = useAuth();
  const [msg, setMsg] = useState("카카오 로그인 처리 중…");
  const once = useRef(false); // StrictMode 이중 실행 방지(code 1회용)

  useEffect(() => {
    if (once.current) return;
    once.current = true;

    const code = params.get("code");
    const error = params.get("error");
    const state = params.get("state"); // Login 에서 넘긴 redirect 경로
    const redirect = state || "/home";

    if (error || !code) {
      setMsg("카카오 로그인이 취소됐어요.");
      setTimeout(() => navigate("/login", { replace: true }), 1200);
      return;
    }

    (async () => {
      try {
        const result = await kakaoLogin(code);
        // 신규 회원이면 추가정보(이름·회원유형) 입력 단계로
        if (result?.isNew) {
          navigate(`/social-signup?redirect=${encodeURIComponent(redirect)}`, { replace: true });
        } else {
          navigate(redirect, { replace: true });
        }
      } catch (err) {
        // TODO(백엔드 연동): 신규회원(추가정보 필요) 응답 분기 — Join/추가정보 플로우로 라우팅.
        setMsg(err?.response?.data?.message || "카카오 로그인에 실패했어요.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container">
      <div
        className="page"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}
      >
        <p className="t-16-single">{msg}</p>
      </div>
    </div>
  );
};

export default KakaoCallback;
